import React, { InputHTMLAttributes } from 'react';
import style from './ui.module.css';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  type?: string;
  error?: boolean;
}

const Input: React.FC<InputProps> = ({ className = '', type = 'text', error = false, ...props }) => {
  const baseStyles = `${style['input-style']}`;

  return (
    <input
      type={type}
      className={`${baseStyles} ${className} ${error ? style['input-error'] : ''}`.trim()}
      /* מצב השגיאה היה ויזואלי בלבד (מסגרת אדומה). aria-invalid מוסר את
         אותו מידע גם למי שלא רואה את המסגרת - WCAG 3.3.1.
         מגיע לפני ה-spread כדי ששימוש נקודתי יוכל לדרוס אותו. */
      aria-invalid={error || undefined}
      {...props}
    />
  );
};

export default Input;
